import React from 'react';
import { TextComponent } from 'baseComponents/TextComponent';
import warningIcon from 'assets/icons/warningIcon.svg';
import './previewBoxComponent.scss';
import { TooltipComponent } from 'baseComponents/TooltipComponent';

interface Props {
  label: string;
  previewMessage?: string;
  hardcodedHeight?: boolean;
  tooltipText?: string;
}

export const PreviewBoxComponent: React.FC<React.PropsWithChildren<Props>> = ({
  hardcodedHeight = false,
  ...props
}) => {
  return (
    <div>
      <div className='label-wrapper'>
        <TextComponent text={props.label} weight='extra-light' />
        {props.tooltipText && (
          <TooltipComponent text={props.tooltipText}>
            <img src={warningIcon} alt='Warning icon' />
          </TooltipComponent>
        )}
      </div>
      <div
        className={`preview-box ${hardcodedHeight ? 'hardcoded-height' : ''}`}
      >
        {props.previewMessage && (
          <div className='preview'>
            <div
              className='preview-message'
              dangerouslySetInnerHTML={{
                __html: props.previewMessage.replaceAll('\n', '<br>'),
              }}
            />
          </div>
        )}
        {props.children}
      </div>
    </div>
  );
};
